export const FiltersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 18 18"
  >
    <g clip-path="url(#a)">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.132"
        d="M2.99 7.476a1.495 1.495 0 1 0 2.99 0 1.495 1.495 0 0 0-2.99 0ZM4.486 2.99v2.99m0 2.991v5.981m5.949-3.296a1.494 1.494 0 1 0-1.464 1.8m0-10.466v7.476m0 2.991v1.495m2.991-9.719a1.495 1.495 0 1 0 2.99 0 1.495 1.495 0 0 0-2.99 0Zm1.495-2.243v.748m0 2.991V8.97m-1.495 5.234h4.485m-2.243-2.243v4.486"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h17.942v17.942H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const TrashIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 16 16"
  >
    <g clip-path="url(#a)">
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.4"
        d="M2.667 4.667h10.666"
      />
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        d="m3.333 4.667.667 8A1.333 1.333 0 0 0 5.333 14h5.334A1.333 1.333 0 0 0 12 12.667l.667-8M6 4.667v-2A.667.667 0 0 1 6.667 2h2.666a.667.667 0 0 1 .667.667v2"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
